import React from "react";
import { Link as RouterLink, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

import PdfFileItem from "@/react-components/PdfFileItem";
import { libraryTypeEnum, tagTypeEnum } from "@/utils/enum";
import url from "@/utils/url";
import { substringEllipsis, isEmpty } from "@/utils";

class ListItem extends React.Component {
  brightenKeyword(val, keyword) {
    if (keyword) {
      var tmpKeyword = keyword.replace(/^["|'|”](.*)["|'|”]$/g, "$1");
      val = val + "";
      const Reg = new RegExp(
        "(" + tmpKeyword.replace(/[(){}.+*?^$|\\\[\]]/g, "\\$&") + ")",
        "gi"
      );
      if (val) {
        return val.replace(Reg, `<font class="text-highlight">$&</font>`);
      }
    } else {
      return val;
    }
  }

  click = () => {
    const {
      history: { push },
      item,
    } = this.props;
    push(item.link);
  };

  tagClick = (item) => {
    const {
      history: { push },
    } = this.props;
    push({
      pathname:
        item.type === tagTypeEnum.report
          ? url.researchSearch
          : url.librarySearch,
      state: { selectTag: item.tcode },
    });
  };

  render() {
    const { item, keyWord, t } = this.props;
    let date = item.publicDate;
    let prefix = "";
    let className = "";
    if (item.libraryType) {
      prefix = `${t("Library_kbn_publish")}：`;
      className = "publish";
      if (item.updateDate) {
        date = item.updateDate;
      }
      if (
        item.updateDate &&
        item.updateDate.slice(0, 10) !== "0001-01-01" &&
        new Date(item.updateDate?.slice(0, 10)) >
          new Date(item.createDate?.slice(0, 10))
      ) {
        date = item.updateDate;
        prefix = `${t("Library_kbn_update")}：`;
        className = "update";
      }
    }
    const pdfClass = item.libraryType === libraryTypeEnum.pdf ? "pdf" : "";
    return (
      <div className="search-result-item">
        {item.libraryType === libraryTypeEnum.pdf ||
        item.libraryType === libraryTypeEnum.link ? (
          <PdfFileItem
            pdfFile={item.link}
            pdfTitle={item.title}
            className={`search-result-item-title 
              ${pdfClass}`}
            itemId={item.id}
            libraryType={item.libraryType}
          />
        ) : (
          <RouterLink className="search-result-item-title" to={item.link}>
            {item.title}
          </RouterLink>
        )}
        <div className="flex-row-vertical-center search-result-item-time">
          {item.libraryType === libraryTypeEnum.pdf ||
          item.libraryType === libraryTypeEnum.link ? (
            <PdfFileItem
              pdfFile={item.link}
              pdfTitle={item.title}
              title={`${prefix}${date?.slice(0, 10)?.replace(/-/g, ".")}`}
              className={`search-result-item-time-pdf ${className}`}
              itemId={item.id}
              libraryType={item.libraryType}
            />
          ) : (
            <span className="search-result-item-time-page" onClick={this.click} tabIndex="0">
              {`${prefix}${date?.slice(0, 10)?.replace(/-/g, ".")}`}
            </span>
          )}
          {item.tagModel && item.tagModel.length > 0 && (
            <div className="search-result-item-time-tag ellipsis-text">
              {item.tagModel.map(
                (item, index) =>
                  !isEmpty(item.text) && (
                    <span
                      key={index}
                      className="search-result-item-time-tag-item single-line-text"
                      onClick={() => this.tagClick(item)}
                      tabIndex="0"
                    >
                      {substringEllipsis(item.text)}
                    </span>
                  )
              )}
            </div>
          )}
        </div>
        <p
          className="search-result-item-content text-max-1-line"
          dangerouslySetInnerHTML={{
            __html: item.summary
              ? this.brightenKeyword(item.summary, keyWord)
              : "",
          }}
        ></p>
      </div>
    );
  }
}

export default withRouter(withTranslation()(ListItem));
